module.exports = __webpack_public_path__ + "img/sleeve_flounce_width.1a5510f7.png";